/**
 * ReportsHarvestInspectionVarietyName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    varietyName?: ?string;
    commodityName?: ?string;
}

export class ReportsHarvestInspectionVarietyName extends React.PureComponent<Props> {
    render() {
        const { varietyName, commodityName = null } = this.props;
        if (varietyName) {
            return varietyName;
        }
        if (commodityName) {
            return commodityName;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    varietyName: makeSelectReportsHarvestInspectionValue('varietyName'),
    commodityName: makeSelectReportsHarvestInspectionValue('commodityName')
});

export default connect(mapStateToProps)(ReportsHarvestInspectionVarietyName);
